__turbopack_context__.v({
  "container": "yRO-hq_container",
  "figure": "yRO-hq_figure",
  "icon": "yRO-hq_icon",
  "numberSign": "yRO-hq_numberSign",
  "rank": "yRO-hq_rank",
  "variant--top10": "yRO-hq_variant--top10",
  "variant--top100": "yRO-hq_variant--top100",
  "variant--top3": "yRO-hq_variant--top3",
  "variant--top50": "yRO-hq_variant--top50",
});
